import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { MarkdownRenderClassNames } from '../../../custom/markdown';

/**
 * Markdown render options that make every link in lesson content a button:
 * an authored `[Label](https://…)` shows its label, a bare URL shows
 * "Open link" (translated). Spread it into the classNames passed to the
 * markdown render helpers.
 */
export function useLessonLinkClasses(): Pick<
  MarkdownRenderClassNames,
  'linkVariant' | 'bareLinkLabel'
> {
  const { t } = useTranslation('p2e');
  const bareLinkLabel = t('lessonLink.open');
  return useMemo(
    () => ({ linkVariant: 'button' as const, bareLinkLabel }),
    [bareLinkLabel]
  );
}
